import TD from "../../Assets/Bat/15AA.png";
import WB from "../../Assets/Web/WebHome.png";
import GF from "../../Assets/Grafisk/GrafiskHome.png";

export const CardsData = [
    {
        image: WB,
        text:"Webutvikling Portfolio",
        label:"Portfolio",
        path:"/Web",
        slug: 0,
    },
    {
        image: TD,
        text:"3D Portfolio",
        label:"Portfolio",
        path:"/3D",
        slug: 1,
    },
    {
        image: GF,
        text:"Grafisk Design Portfolio",
        label:"Portfolio",
        path:"/Grafisk",
        slug: 2,
    },
];